// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: AgdF0DgOMW
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: Z-JBWeJQzP-/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicProjectCard.module.css"; // plasmic-import: AgdF0DgOMW/css

import XSvgrepoComsvgIcon from "./icons/PlasmicIcon__XSvgrepoComsvg"; // plasmic-import: bhCqgTTbQ_/icon
import FileSvgrepoComsvgIcon from "./icons/PlasmicIcon__FileSvgrepoComsvg"; // plasmic-import: ti9TN1ijP8/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: 074BTgmJsHD/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import MenuSvgrepoComsvgIcon from "./icons/PlasmicIcon__MenuSvgrepoComsvg"; // plasmic-import: 1LwT8MArdA/icon

export type PlasmicProjectCard__VariantMembers = {
  state: "uploading" | "editingMenu" | "editingName";
};

export type PlasmicProjectCard__VariantsArgs = {
  state?: SingleChoiceArg<"uploading" | "editingMenu" | "editingName">;
};

type VariantPropType = keyof PlasmicProjectCard__VariantsArgs;
export const PlasmicProjectCard__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicProjectCard__ArgsType = {
  children?: React.ReactNode;
  children3?: React.ReactNode;
  slot2?: React.ReactNode;
};

type ArgPropType = keyof PlasmicProjectCard__ArgsType;
export const PlasmicProjectCard__ArgProps = new Array<ArgPropType>(
  "children",
  "children3",
  "slot2"
);

export type PlasmicProjectCard__OverridesType = {
  root?: p.Flex<"div">;
  projectLink?: p.Flex<"div">;
  close?: p.Flex<"svg">;
  renameOption?: p.Flex<"button">;
  deleteOption?: p.Flex<"button">;
  columns?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  projectName?: p.Flex<"div">;
  textbox?: p.Flex<typeof TextInput>;
  settings?: p.Flex<"svg">;
};

export interface DefaultProjectCardProps {
  children?: React.ReactNode;
  children3?: React.ReactNode;
  slot2?: React.ReactNode;
  state?: SingleChoiceArg<"uploading" | "editingMenu" | "editingName">;
  className?: string;
}

function PlasmicProjectCard__RenderFunc(props: {
  variants: PlasmicProjectCard__VariantsArgs;
  args: PlasmicProjectCard__ArgsType;
  overrides: PlasmicProjectCard__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      <div className={classNames(projectcss.all, sty.freeBox__gndM)}>
        <div
          className={classNames(projectcss.all, sty.freeBox__kmzdh, {
            [sty.freeBoxstate_editingMenu__kmzdhroNkM]: hasVariant(
              variants,
              "state",
              "editingMenu"
            ),
            [sty.freeBoxstate_uploading__kmzdh9Rk5]: hasVariant(
              variants,
              "state",
              "uploading"
            )
          })}
        >
          <div
            data-plasmic-name={"projectLink"}
            data-plasmic-override={overrides.projectLink}
            className={classNames(projectcss.all, sty.projectLink)}
          />

          {(
            hasVariant(variants, "state", "editingMenu")
              ? true
              : hasVariant(variants, "state", "uploading")
              ? true
              : true
          ) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox___5YpIl, {
                [sty.freeBoxstate_editingMenu___5YpILroNkM]: hasVariant(
                  variants,
                  "state",
                  "editingMenu"
                ),
                [sty.freeBoxstate_uploading___5YpIl9Rk5]: hasVariant(
                  variants,
                  "state",
                  "uploading"
                )
              })}
            >
              <XSvgrepoComsvgIcon
                data-plasmic-name={"close"}
                data-plasmic-override={overrides.close}
                className={classNames(projectcss.all, sty.close)}
                role={"img"}
              />

              <button
                data-plasmic-name={"renameOption"}
                data-plasmic-override={overrides.renameOption}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.renameOption
                )}
              >
                <div className={classNames(projectcss.all, sty.freeBox__yfWrc)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "Rename",
                    value: args.children3
                  })}
                </div>
              </button>

              <button
                data-plasmic-name={"deleteOption"}
                data-plasmic-override={overrides.deleteOption}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.deleteOption
                )}
              >
                <div className={classNames(projectcss.all, sty.freeBox__mYjmY)}>
                  {p.renderPlasmicSlot({
                    defaultContents: "Delete",
                    value: args.slot2
                  })}
                </div>
              </button>
            </div>
          ) : null}

          <div
            className={classNames(projectcss.all, sty.freeBox__yyxP, {
              [sty.freeBoxstate_uploading__yyxP9Rk5]: hasVariant(
                variants,
                "state",
                "uploading"
              )
            })}
          >
            <div
              data-plasmic-name={"columns"}
              data-plasmic-override={overrides.columns}
              className={classNames(projectcss.all, sty.columns, {
                [sty.columnsstate_editingMenu]: hasVariant(
                  variants,
                  "state",
                  "editingMenu"
                )
              })}
            >
              <div
                className={classNames(projectcss.all, sty.column__oag8G, {
                  [sty.columnstate_editingMenu__oag8GroNkM]: hasVariant(
                    variants,
                    "state",
                    "editingMenu"
                  ),
                  [sty.columnstate_editingName__oag8GprzX]: hasVariant(
                    variants,
                    "state",
                    "editingName"
                  )
                })}
              >
                <FileSvgrepoComsvgIcon
                  data-plasmic-name={"svg"}
                  data-plasmic-override={overrides.svg}
                  className={classNames(projectcss.all, sty.svg)}
                  role={"img"}
                />
              </div>

              <div
                className={classNames(projectcss.all, sty.column__hOdnw, {
                  [sty.columnstate_editingMenu__hOdnwroNkM]: hasVariant(
                    variants,
                    "state",
                    "editingMenu"
                  ),
                  [sty.columnstate_editingName__hOdnwprzX]: hasVariant(
                    variants,
                    "state",
                    "editingName"
                  )
                })}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox__qMgZ, {
                    [sty.freeBoxstate_editingMenu__qMgZroNkM]: hasVariant(
                      variants,
                      "state",
                      "editingMenu"
                    ),
                    [sty.freeBoxstate_editingName__qMgZprzX]: hasVariant(
                      variants,
                      "state",
                      "editingName"
                    )
                  })}
                >
                  {(
                    hasVariant(variants, "state", "editingMenu") ? true : true
                  ) ? (
                    <div
                      data-plasmic-name={"projectName"}
                      data-plasmic-override={overrides.projectName}
                      className={classNames(projectcss.all, sty.projectName, {
                        [sty.projectNamestate_editingMenu]: hasVariant(
                          variants,
                          "state",
                          "editingMenu"
                        ),
                        [sty.projectNamestate_editingName]: hasVariant(
                          variants,
                          "state",
                          "editingName"
                        )
                      })}
                    >
                      {(
                        hasVariant(variants, "state", "editingMenu")
                          ? true
                          : true
                      ) ? (
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__pdhQo,
                            {
                              [sty.freeBoxstate_editingMenu__pdhQOroNkM]:
                                hasVariant(variants, "state", "editingMenu")
                            }
                          )}
                        >
                          {(
                            hasVariant(variants, "state", "editingName")
                              ? false
                              : true
                          )
                            ? p.renderPlasmicSlot({
                                defaultContents: "Title",
                                value: args.children,
                                className: classNames(sty.slotTargetChildren, {
                                  [sty.slotTargetChildrenstate_editingMenu]:
                                    hasVariant(
                                      variants,
                                      "state",
                                      "editingMenu"
                                    ),
                                  [sty.slotTargetChildrenstate_editingName]:
                                    hasVariant(variants, "state", "editingName")
                                })
                              })
                            : null}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {(
                    hasVariant(variants, "state", "editingName") ? true : true
                  ) ? (
                    <TextInput
                      data-plasmic-name={"textbox"}
                      data-plasmic-override={overrides.textbox}
                      className={classNames("__wab_instance", sty.textbox, {
                        [sty.textboxstate_editingMenu]: hasVariant(
                          variants,
                          "state",
                          "editingMenu"
                        ),
                        [sty.textboxstate_editingName]: hasVariant(
                          variants,
                          "state",
                          "editingName"
                        )
                      })}
                    />
                  ) : null}
                </div>
              </div>

              <div
                className={classNames(projectcss.all, sty.column__lIkH, {
                  [sty.columnstate_editingMenu__lIkHroNkM]: hasVariant(
                    variants,
                    "state",
                    "editingMenu"
                  ),
                  [sty.columnstate_editingName__lIkHprzX]: hasVariant(
                    variants,
                    "state",
                    "editingName"
                  )
                })}
              >
                {(
                  triggers.hover_root
                    ? true
                    : hasVariant(variants, "state", "editingMenu")
                    ? true
                    : hasVariant(variants, "state", "uploading")
                    ? true
                    : true
                ) ? (
                  <MenuSvgrepoComsvgIcon
                    data-plasmic-name={"settings"}
                    data-plasmic-override={overrides.settings}
                    className={classNames(projectcss.all, sty.settings, {
                      [sty.settingsstate_editingMenu]: hasVariant(
                        variants,
                        "state",
                        "editingMenu"
                      ),
                      [sty.settingsstate_editingName]: hasVariant(
                        variants,
                        "state",
                        "editingName"
                      ),
                      [sty.settingsstate_uploading]: hasVariant(
                        variants,
                        "state",
                        "uploading"
                      )
                    })}
                    role={"img"}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "projectLink",
    "close",
    "renameOption",
    "deleteOption",
    "columns",
    "svg",
    "projectName",
    "textbox",
    "settings"
  ],
  projectLink: ["projectLink"],
  close: ["close"],
  renameOption: ["renameOption"],
  deleteOption: ["deleteOption"],
  columns: ["columns", "svg", "projectName", "textbox", "settings"],
  svg: ["svg"],
  projectName: ["projectName"],
  textbox: ["textbox"],
  settings: ["settings"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  projectLink: "div";
  close: "svg";
  renameOption: "button";
  deleteOption: "button";
  columns: "div";
  svg: "svg";
  projectName: "div";
  textbox: typeof TextInput;
  settings: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProjectCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProjectCard__VariantsArgs;
    args?: PlasmicProjectCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProjectCard__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProjectCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicProjectCard__ArgProps,
          internalVariantPropNames: PlasmicProjectCard__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicProjectCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProjectCard";
  } else {
    func.displayName = `PlasmicProjectCard.${nodeName}`;
  }
  return func;
}

export const PlasmicProjectCard = Object.assign(
  // Top-level PlasmicProjectCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    projectLink: makeNodeComponent("projectLink"),
    close: makeNodeComponent("close"),
    renameOption: makeNodeComponent("renameOption"),
    deleteOption: makeNodeComponent("deleteOption"),
    columns: makeNodeComponent("columns"),
    svg: makeNodeComponent("svg"),
    projectName: makeNodeComponent("projectName"),
    textbox: makeNodeComponent("textbox"),
    settings: makeNodeComponent("settings"),

    // Metadata about props expected for PlasmicProjectCard
    internalVariantProps: PlasmicProjectCard__VariantProps,
    internalArgProps: PlasmicProjectCard__ArgProps
  }
);

export default PlasmicProjectCard;
/* prettier-ignore-end */
